import "./vendor";


if (document.querySelector(".js-choice")) {
	window.loadChoices().then(function (Choices) {
		document
			.querySelectorAll(".js-choice")
			.forEach((select) => new Choices(select));
	});
}

if (document.querySelector(".slider") || document.querySelector(".calendarslider")) {
	window.loadSlick().then(function () {
		$(".slider").slick({
			dots: false,
			speed: 1000,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 5000,
			prevArrow:
				'<button type="button" class="btn-slider prev" aria-label="Previous slide"><svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.2931 15.2071C8.90258 14.8166 8.90258 14.1834 9.2931 13.7929L15.6571 7.42893C16.0476 7.03841 16.6808 7.03841 17.0713 7.42893C17.4618 7.81946 17.4618 8.45262 17.0713 8.84315L11.4144 14.5L17.0713 20.1569C17.4618 20.5474 17.4618 21.1805 17.0713 21.5711C16.6808 21.9616 16.0476 21.9616 15.6571 21.5711L9.2931 15.2071ZM10.5181 15.5L10.0002 15.5L10.0002 13.5L10.5181 13.5L10.5181 15.5Z" fill="currentColor"/></svg></button>',
			nextArrow:
				'<button type="button" class="btn-slider next" aria-label="Next slide"><svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.225 15.2071C19.6155 14.8166 19.6155 14.1834 19.225 13.7929L12.861 7.42893C12.4705 7.03841 11.8373 7.03841 11.4468 7.42893C11.0563 7.81946 11.0563 8.45262 11.4468 8.84315L17.1036 14.5L11.4468 20.1569C11.0563 20.5474 11.0563 21.1805 11.4468 21.5711C11.8373 21.9616 12.4705 21.9616 12.861 21.5711L19.225 15.2071ZM18 15.5L18.5179 15.5L18.5179 13.5L18 13.5L18 15.5Z" fill="currentColor"/></svg></button>',
		});

		$(".calendarslider").slick({
			dots: false,
			speed: 1000,
			infinite: true,
			slidesToShow: 4,
			slidesToScroll: 1,
			variableWidth: true,
			prevArrow: "",
			nextArrow:
				'<button type="button" class="btn-slider next" aria-label="Next slide"><svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.225 15.2071C19.6155 14.8166 19.6155 14.1834 19.225 13.7929L12.861 7.42893C12.4705 7.03841 11.8373 7.03841 11.4468 7.42893C11.0563 7.81946 11.0563 8.45262 11.4468 8.84315L17.1036 14.5L11.4468 20.1569C11.0563 20.5474 11.0563 21.1805 11.4468 21.5711C11.8373 21.9616 12.4705 21.9616 12.861 21.5711L19.225 15.2071ZM18 15.5L18.5179 15.5L18.5179 13.5L18 13.5L18 15.5Z" fill="currentColor"></path></svg></button>'
		});
	});
}

$(".tabsblock").each(function () {
	let $wrapper = $(this);
	$wrapper.find(".tabsblock__contentitem").not(":first").hide();
	$wrapper
		.find(".tabsblock__tab")
		.click(function () {
			let index = $(this).index();
			$wrapper
				.find(".tabsblock__tab")
				.removeClass("is-active")
				.eq(index)
				.addClass("is-active");
			$wrapper.find(".tabsblock__contentitem").hide().eq(index).fadeIn();
		})
		.eq(0)
		.addClass("is-active");
});
$(".equities").each(function () {
	let $wrapper = $(this);
	$wrapper.find(".equities__contentitem").not(":first").hide();
	$wrapper
		.find(".equities__tab")
		.click(function () {
			let index = $(this).index();
			$wrapper
				.find(".equities__tab")
				.removeClass("is-active")
				.eq(index)
				.addClass("is-active");
			$wrapper.find(".equities__contentitem").hide().eq(index).fadeIn();
		})
		.eq(0)
		// .addClass("is-active");
});
$(".msgs").each(function () {
	let $wrapper = $(this);

	$wrapper.find(".msgs__items").not(":first").hide();

	$wrapper.find(".msgs__tab").click(function () {
		let index = $(this).index();

		$wrapper
			.find(".msgs__tab")
			.removeClass("is-active")
			.eq(index)
			.addClass("is-active");

		let $panel = $wrapper.find(".msgs__items").hide().eq(index).fadeIn();

		$panel.find("iframe[data-src]").each(function () {
			this.src = this.dataset.src;
			this.removeAttribute("data-src");
		});
	});

	$wrapper.find(".msgs__tab").eq(0).addClass("is-active");
});
  $(".years-selector").each(function () {
    let $selector = $(this);
    let $current = $selector.find(".years-selector__current");
    let $dropdown = $selector.find(".years-selector__dropdown");
    let $options = $selector.find(".years-selector__option");
    let $text = $selector.find(".years-selector__text");

    $current.click(function(e) {
      e.stopPropagation();

      $(".years-selector").not($selector).removeClass("is-open")
        .find(".years-selector__dropdown").removeClass("is-open");

      $selector.toggleClass("is-open");
      $dropdown.toggleClass("is-open");
    });

    $options.click(function(e) {
      e.stopPropagation();

      let selectedYear = $(this).data("year");
      let selectedText = $(this).text();

      $options.removeClass("is-selected");
      $(this).addClass("is-selected");

      $text.text(selectedText);

      $selector.removeClass("is-open");
      $dropdown.removeClass("is-open");

      showYearContent(selectedYear);
    });
  });

  function showYearContent(year) {
    let $contentItems = $(".years-content__item");

    $contentItems.removeClass("is-active");

    $contentItems.filter('[data-year="' + year + '"]').addClass("is-active");
  }

  $(document).click(function() {
    $(".years-selector").removeClass("is-open");
    $(".years-selector__dropdown").removeClass("is-open");
  });

  $(".years-selector").click(function(e) {
    e.stopPropagation();
  });

  let defaultYear = $(".years-selector__option.is-selected").data("year") || "2025";
  showYearContent(defaultYear);

if (document.querySelector(".popup-with-form")) {
	window.loadMagnificPopup().then(function () {
		$(".popup-with-form").magnificPopup({
			type: "inline",
			preloader: false,
			focus: "#name",
			mainClass: "mfp-fade",
			callbacks: {
				beforeOpen: function () {
					if ($(window).width() < 700) {
						this.st.focus = false;
					} else {
						this.st.focus = "#name";
					}
				},
			},
		});
	});
}

$(document).on("click", ".member-modal__close", function () {
	if ($.magnificPopup) $.magnificPopup.close();
});

document.addEventListener("DOMContentLoaded", () => {
	const items = document.querySelectorAll(".categories__item");

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting && entry.intersectionRatio === 1) {
					entry.target.classList.add("is-active");
				} else {
					entry.target.classList.remove("is-active");
				}
			});
		},
		{
			root: document.querySelector(".categories"), // Ограничение области наблюдения
			threshold: 1.0, // Элемент должен быть полностью видим
		}
	);

	items.forEach((item) => observer.observe(item));
});

$(".accordeon dd")
	.hide()
	.prev()
	.click(function () {
		$(this)
			.parents(".accordeon")
			.find("dd")
			.not(this)
			.slideUp()
			.prev()
			.removeClass("active");
		$(this).next().not(":visible").slideDown().prev().addClass("active");
	});



document.querySelectorAll(".acc-card__heading").forEach((heading) => {
	heading.addEventListener("click", function () {

		const parentCard = this.closest(".acc-card");
		const hideContent = parentCard.querySelector(".acc-card__hidecontent");

		this.classList.toggle("is-active");
		if (hideContent) {
			hideContent.style.display =
				hideContent.style.display === "block" ? "none" : "block";
		}
	});
});

let btnMenu = document.querySelectorAll(".header__btnmenu");
let btnMenu2 = document.querySelectorAll(".header__btn--search");

function setSubmenuScroll(submenu, isActive) {
    if (isActive) {
        const header = document.querySelector(".header");
        submenu.style.maxHeight = (window.innerHeight - header.offsetHeight) + "px";
        submenu.style.overflowY = "auto";
    } else {
        submenu.style.maxHeight = "";
        submenu.style.overflowY = "";
    }
}

btnMenu.forEach((btn) => {
    btn.addEventListener("click", () => {
        const submenu = document.querySelector(".submenu");
        const isActive = submenu.classList.toggle("is-active");
        btn.classList.toggle("is-open");
        setSubmenuScroll(submenu, isActive);

        document.querySelector(".searchblock").classList.remove("is-open");
        btnMenu2.forEach((searchBtn) => {
            searchBtn.classList.remove("is-open");
        });
    });
});

btnMenu2.forEach((btn) => {
    btn.addEventListener("click", () => {
        document.querySelector(".searchblock").classList.toggle("is-open");
        btn.classList.toggle("is-open");

        const submenu = document.querySelector(".submenu");
        submenu.classList.remove("is-active");
        setSubmenuScroll(submenu, false);
        btnMenu.forEach((menuBtn) => {
            menuBtn.classList.remove("is-open");
        });
    });
});


function checkAndCloseIfSubmenu2Active() {
  const submenu = document.querySelector(".submenu");
  submenu.classList.remove("is-active");
  setSubmenuScroll(submenu, false);
  btnMenu.forEach((menuBtn) => {
      menuBtn.classList.remove("is-open");
  });
  document.querySelector(".searchblock").classList.remove("is-open");
  btnMenu2.forEach((searchBtn) => {
      searchBtn.classList.remove("is-open");
  });
}

const submenu2Triggers = document.querySelectorAll(".link-with-submenu");
submenu2Triggers.forEach((trigger) => {
    trigger.addEventListener("mouseenter", () => {
        checkAndCloseIfSubmenu2Active();
    });
});

// let linkMenu = document.querySelectorAll(".link-with-submenu");
// let submenu = document.querySelectorAll(".submenu2__item ");
// let submenuContainer =  document.querySelector(".submenu2");
// linkMenu.forEach((link, index) => {
// 	link.addEventListener("mouseenter", ()=> {
// 		submenu.forEach(el => {
// 			el.classList.remove("is-active")
// 		})
// 		submenu[index].classList.add("is-active")
// 		submenuContainer.classList.add("is-active")
// 	})

// 	link.addEventListener("mouseleave", ()=> {
// 		submenuContainer.classList.remove("is-active")
// 	});
// });

document.addEventListener("DOMContentLoaded", function () {
	function isMobile() {
		return window.innerWidth >= 320 && window.innerWidth <= 992;
	}

	function toggleSubmenuSpan(span) {
		const ul = span.nextElementSibling;
		if (ul && ul.tagName === "UL") {
			const isVisible = ul.style.display === "block";
			ul.style.display = isVisible ? "none" : "block";

			span.classList.toggle('is-active', !isVisible);
			if (span.hasAttribute('aria-expanded')) {
				span.setAttribute('aria-expanded', String(!isVisible));
			}
		}
	}

	function initMobileSubmenu() {
		const spans = document.querySelectorAll(".submenu__container span");

		spans.forEach((span) => {
			span.addEventListener("click", function (e) {
				if (isMobile()) {
					e.stopPropagation();
					toggleSubmenuSpan(this);
				}
			});
			span.addEventListener("keydown", function (e) {
				if (isMobile() && (e.key === "Enter" || e.key === " ")) {
					e.preventDefault();
					e.stopPropagation();
					toggleSubmenuSpan(this);
				}
			});
		});
	}
	function initDesktopSubmenu() {
		const submenuButtons = document.querySelectorAll('.submenu__btn');

		submenuButtons.forEach(function (btn) {
			btn.addEventListener('click', function (e) {
				if (!isMobile()) {
					e.stopPropagation();
					toggleSubmenuSpan(this);
				}
			});
		});
	}

	initMobileSubmenu();
	initDesktopSubmenu();

	window.addEventListener("resize", function () {
		if (window.innerWidth > 992) {
			const uls = document.querySelectorAll(".submenu__container ul ul");
			uls.forEach((ul) => {
				ul.style.display = "";
			});

			const activeElements = document.querySelectorAll('.submenu__container .is-active');
			activeElements.forEach(el => {
				el.classList.remove('is-active');
			});
		}
	});
});

document.querySelectorAll('.submenu__container li').forEach((li) => {
	if (li.querySelector('ul')) {
		li.classList.add('has-submenu');
	}
});


function initAccordion() {
  const accordionHeaders = document.querySelectorAll('.accordion-header');

  accordionHeaders.forEach(header => {
      header.addEventListener('click', function() {
          toggleAccordion(this);
      });
  });
}

function toggleAccordion(header) {
  const item = header.parentElement;
  const content = item.querySelector('.accordion-content');
  const isActive = header.classList.contains('is-active');

  closeAllAccordions(header);

  if (isActive) {
      header.classList.remove('is-active');
      content.classList.remove('is-open');
  } else {
      header.classList.add('is-active');
      content.classList.add('is-open');
  }
}

function closeAllAccordions(currentHeader) {
  const allHeaders = document.querySelectorAll('.accordion-header');

  allHeaders.forEach(header => {
      if (header !== currentHeader) {
          header.classList.remove('is-active');
          const content = header.parentElement.querySelector('.accordion-content');
          content.classList.remove('is-open');
      }
  });
}

const asideStaticMQ = window.matchMedia('(max-width: 991px)');

function syncAsideToggleState() {
  document.querySelectorAll('.asidemenu > li:has(ul) > span.asidemenu__toggle').forEach(span => {
    if (asideStaticMQ.matches) {
      span.removeAttribute('role');
      span.removeAttribute('tabindex');
      span.removeAttribute('aria-expanded');
    } else {
      span.setAttribute('role', 'button');
      span.setAttribute('tabindex', '0');
      if (!span.hasAttribute('aria-expanded')) {
        span.setAttribute('aria-expanded', 'false');
      }
    }
  });
  document.querySelectorAll('.asidemenu .toggle-icon').forEach(icon => {
    if (asideStaticMQ.matches) {
      icon.style.removeProperty('display');
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initAccordion();
  document.querySelectorAll('.asidemenu > li:has(ul) > a, .asidemenu > li:has(ul) > span.asidemenu__toggle').forEach(link => {
    const svgIcon = document.createElement('span');
    svgIcon.classList.add('toggle-icon');
    svgIcon.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="currentColor">
        <path d="M11.3539 6.46967C11.6468 6.76256 11.6468 7.23744 11.3539 7.53033L6.58089 12.3033C6.288 12.5962 5.81312 12.5962 5.52023 12.3033C5.22734 12.0104 5.22734 11.5355 5.52023 11.2426L9.76287 7L5.52023 2.75736C5.22734 2.46447 5.22734 1.98959 5.52023 1.6967C5.81312 1.40381 6.288 1.40381 6.58089 1.6967L11.3539 6.46967Z"/>
      </svg>
    `;
    link.appendChild(svgIcon);

    function toggleAside() {
      if (asideStaticMQ.matches) return;
      const sublist = link.nextElementSibling;
      if (sublist && sublist.tagName === 'UL') {
        sublist.classList.toggle('open');
        const isOpen = sublist.classList.contains('open');
        svgIcon.style.display = isOpen ? 'none' : 'inline-block';
        if (link.hasAttribute('aria-expanded')) {
          link.setAttribute('aria-expanded', String(isOpen));
        }
      }
    }

    link.addEventListener('click', function (e) {
      e.preventDefault();
      toggleAside();
    });
    link.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleAside();
      }
    });
  });

  document.querySelectorAll('.asidemenu li ul').forEach(sublist => {

    const activeSpan = sublist.querySelector('.active');

    if (activeSpan) {
      sublist.classList.add('open');

      const parentLink = sublist.previousElementSibling;
      let svgIcon = null;
      if (parentLink) {
        svgIcon = parentLink.querySelector('.toggle-icon');
      }
      if (svgIcon && !asideStaticMQ.matches) {
        svgIcon.style.display = 'none';
      }
    }
  });
  syncAsideToggleState();
  asideStaticMQ.addEventListener('change', syncAsideToggleState);

  let debounceTimer;
  document.querySelector('input[name="s"]').addEventListener('input', function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
        this.form.submit();
    }, 500);
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const menuItems = document.querySelectorAll('.submenu2__item > ul > li');

  menuItems.forEach(function(item) {
      const hasSubmenu = item.querySelector('ul');
      if (!hasSubmenu) {
          item.classList.add('no-submenu');
      } else {
          item.classList.add('has-submenu');
      }
  });
});

document.addEventListener('DOMContentLoaded', function() {

  $(document).on('click', '.dynamic-modal-trigger', function(e) {
      e.preventDefault();

      var href = $(this).attr('href');
      var pageId = null;

      if (href && href.startsWith('#modal-')) {
          pageId = href.replace('#modal-', '');
      }

      if (!pageId) {
          console.error('Page ID not found in href');
          return;
      }

      window.loadMagnificPopup().then(function () {
          var modalHtml = `
              <div class="custom-modal" id="dynamic-modal-${pageId}">
                  <div class="custom-modal__header">
                      <div class="custom-modal__heading">Loading...</div>
                      <div class="custom-modal__nav">
                          <div class="member-modal__close">
                              <svg><use xlink:href="/images/site/sprites.svg#close"></use></svg>
                          </div>
                      </div>
                  </div>
                  <div class="custom-modal__body">
                      <div class="typography">
                        <div class="loading">Loading content...</div>
                      </div>
                  </div>
              </div>
          `;

          $('#dynamic-modal-' + pageId).remove();

          $('body').append(modalHtml);

          $.magnificPopup.open({
              items: { src: '#dynamic-modal-' + pageId, type: 'inline' },
              mainClass: 'mfp-fade',
              callbacks: {
                  open: function() {
                      loadPageData(pageId);
                  },
                  close: function() {
                      $('#dynamic-modal-' + pageId).remove();
                  }
              }
          });
      });
  });

  function loadPageData(pageId) {
      $.ajax({
          url: '/pages/popup/' + pageId,
          method: 'GET',
          success: function(data) {
              $('#dynamic-modal-' + pageId + ' .custom-modal__heading').text(data.name || '');
              $('#dynamic-modal-' + pageId + ' .typography').html(data.description || '');
          },
          error: function() {
              $('#dynamic-modal-' + pageId + ' .custom-modal__heading').text('Ошибка');
              $('#dynamic-modal-' + pageId + ' .typography').html('Не удалось загрузить контент');
          }
      });
  }
});

// Apple devices open mailto: links in the native Mail app just fine.
document.addEventListener('DOMContentLoaded', function () {
  var isAppleDevice = /Mac|iPhone|iPad|iPod/i.test(
      (navigator.userAgentData && navigator.userAgentData.platform) ||
      navigator.platform ||
      navigator.userAgent ||
      ''
  );

  if (isAppleDevice) return;

  document.querySelectorAll('a[href^="mailto:"]').forEach(function (link) {
      var gmailUrl = mailtoToGmailCompose(link.getAttribute('href'));
      if (!gmailUrl) return;

      link.setAttribute('href', gmailUrl);
      if (!link.hasAttribute('target')) link.setAttribute('target', '_blank');
  });

  function mailtoToGmailCompose(mailto) {
      var match = /^mailto:([^?]*)(?:\?(.*))?$/i.exec(mailto);
      if (!match) return null;

      var to = decodeURIComponent(match[1] || '');
      var params = new URLSearchParams(match[2] || '');
      var gmailParams = new URLSearchParams();

      gmailParams.set('view', 'cm');
      gmailParams.set('fs', '1');
      if (to) gmailParams.set('to', to);
      if (params.has('cc')) gmailParams.set('cc', params.get('cc'));
      if (params.has('bcc')) gmailParams.set('bcc', params.get('bcc'));
      if (params.has('subject')) gmailParams.set('su', params.get('subject'));
      if (params.has('body')) gmailParams.set('body', params.get('body'));

      return 'https://mail.google.com/mail/?' + gmailParams.toString();
  }
});

window.tickerLogos = window.tickerLogos || {};

function getTickerLogoCandidates(secCode) {
    if (!secCode) return [];
    if (window.tickerLogos[secCode]) return [window.tickerLogos[secCode]];

    var fullCode = secCode.toLowerCase();
    var baseCode = fullCode.split('.')[0];
    var candidates = ['/images/logos/' + fullCode + '.png', '/images/logos/' + fullCode + '.svg'];

    if (baseCode !== fullCode) {
        candidates.push('/images/logos/' + baseCode + '.png', '/images/logos/' + baseCode + '.svg');
    }

    return candidates;
}

window.tickerLogoFallback = function(img) {
    var remaining = (img.getAttribute('data-fallback') || '').split(',').filter(Boolean);
    if (remaining.length === 0) {
        img.remove();
        return;
    }
    var next = remaining.shift();
    img.setAttribute('data-fallback', remaining.join(','));
    img.src = next;
};

var lastRenderedEquitiesData = null;

window.updateTickerDisplay = function() {
    if (typeof allEquitiesData === 'undefined' || !allEquitiesData || allEquitiesData.length === 0) {
        $('.ticker').hide();
        lastRenderedEquitiesData = null;
        return;
    }

    if (lastRenderedEquitiesData === allEquitiesData) {
        return;
    }
    lastRenderedEquitiesData = allEquitiesData;

    var html = '';
    allEquitiesData.forEach(function(q) {
        if (q.assetClass !== 'EQTY') return;
        var hasTrade = parseFloat(q.lastTrade) > 0;
        var lastTrade = parseFloat(q.lastTrade) || parseFloat(q.referencePrice) || parseFloat(q.previousClose) || 0;
        if (lastTrade === 0) return;
        var percentChange = hasTrade ? (parseFloat(q.percentChange) || 0) : 0;
        var isUp = percentChange > 0;
        var isDown = percentChange < 0;
        var percentClass = isUp ? 'ticker__percent--up' : (isDown ? 'ticker__percent--down' : '');
        var arrowClass = isUp ? 'ticker__arrow--up' : (isDown ? 'ticker__arrow--down' : 'ticker__arrow--neutral');
        var arrow = isUp ? '&#9650;' : (isDown ? '&#9660;' : '<span class="ticker__arrow-half ticker__arrow-half--left">&#9650;</span><span class="ticker__arrow-half ticker__arrow-half--right">&#9650;</span>');

        var logoCandidates = getTickerLogoCandidates(q.secCode);

        html += '<span class="ticker__item">';
        if (logoCandidates.length > 0) {
            var logoSrc = logoCandidates[0];
            var logoFallback = logoCandidates.slice(1).join(',');
            html += '<img class="ticker__logo" src="' + logoSrc + '" alt="" data-fallback="' + logoFallback + '" onerror="window.tickerLogoFallback(this)">';
        }
        html += '<span class="ticker__code">' + (q.secCode || '-') + '</span>';
        html += '<span class="ticker__arrow ' + arrowClass + '">' + arrow + '</span>';
        html += '<span class="ticker__price">' + lastTrade.toFixed(2) + '</span>';
        html += '<span class="ticker__percent ' + percentClass + '">' + percentChange.toFixed(2) + '%</span>';
        html += '</span>';
    });

    var $track = $('.ticker__track');
    if(html.length > 0){
        $track.parent().css('display', 'flex');
        $track.html(html + html);
    }else{
        $track.parent().css('display', 'none');
    }

    var trackWidth = $track[0].scrollWidth;
    var duration = (trackWidth / 2) / 50;
    $track.css('animation-duration', duration + 's');
};

document.addEventListener('click', function (e) {
	var facade = e.target.closest('.video-facade');
	if (!facade) return;

	var embedHtml = facade.dataset.embed;
	if (!embedHtml) return;

	var wrapper = document.createElement('div');
	wrapper.className = 'slide__video-embed';
	wrapper.innerHTML = embedHtml;
	facade.replaceWith(wrapper);
});


document.addEventListener('DOMContentLoaded', function () {
	var lazyIframes = document.querySelectorAll('iframe[data-src]');
	if (!lazyIframes.length) return;

	function loadIframe(iframe) {
		if (!iframe.dataset.src) return;
		iframe.src = iframe.dataset.src;
		iframe.removeAttribute('data-src');
	}

	if ('IntersectionObserver' in window) {
		var observer = new IntersectionObserver(function (entries, obs) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					loadIframe(entry.target);
					obs.unobserve(entry.target);
				}
			});
		}, { rootMargin: '200px 0px' });

		lazyIframes.forEach(function (iframe) {
			observer.observe(iframe);
		});
	} else {
		lazyIframes.forEach(loadIframe);
	}
});
